export default __webpack_public_path__ + "static/media/Chevron.9daf247f.svg";